export const Svg_110 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="m33.98 42.073 16.625-16.625-3.063-2.99-13.49 13.563-7.072-7.073-3.063 3.063L33.98 42.073ZM17.209 55.417c-1.167 0-2.188-.437-3.063-1.312s-1.312-1.896-1.312-3.063V10.21c0-1.167.437-2.188 1.312-3.063s1.896-1.312 3.063-1.312h40.833c1.167 0 2.188.437 3.063 1.312s1.312 1.896 1.312 3.063v40.833c0 1.167-.437 2.188-1.312 3.063s-1.896 1.312-3.063 1.312H17.21Zm0-4.375h40.833V10.21H17.21v40.833Zm-8.75 13.125c-1.167 0-2.188-.437-3.063-1.312s-1.312-1.896-1.312-3.063V14.584h4.375v45.208h45.208v4.375H8.46Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={17.573}
        x2={45.282}
        y1={14.584}
        y2={59.428}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)